import React from "react"
import { generatePath, Link } from "react-router-dom"
import * as routes from "../../../../../library/constants/routes"

const UserProfilePublicCounters = ({ userInfo, type }) => {
  const friendsURL = generatePath(routes.FRIENDS, { userId: userInfo.id })
  const knowCredURL = generatePath(routes.KNOWCRED, { userId: userInfo.id })
  const groupsURL = generatePath(routes.GROUPS, { userId: userInfo.id })
  const productsURL = generatePath(routes.USER_PRODUCTS, {
    userId: userInfo.id,
  })
  return (
    <div className="user-profile-info__public-counters">
      <Link to={friendsURL} className="public-counter">
        <span className="public-counter__value">{userInfo.friends_number}</span>
        <span className="public-counter__name">friends</span>
      </Link>
      <Link to={knowCredURL} className="public-counter">
        <span className="public-counter__value">
          {userInfo.knowcreds_number}
        </span>
        <span className="public-counter__name">Creds</span>
      </Link>
      {/*<Link to={productsURL} className="public-counter">*/}
      {/*  <span className="public-counter__value">*/}
      {/*    {userInfo.products_number}*/}
      {/*  </span>*/}
      {/*  <span className="public-counter__name">Products</span>*/}
      {/*</Link>*/}
      {type === "my-profile" && (
        <Link to={groupsURL} className="public-counter">
          <span className="public-counter__value">
            {userInfo.groups_number}
          </span>
          <span className="public-counter__name">groups</span>
        </Link>
      )}
    </div>
  )
}

export default UserProfilePublicCounters
